import captain from "./captain.component";
import captainUrls from "./captain.urls";
import CaptainTransforms from "./captain.transforms";

const captainModule = angular
  .module("app.components.captain", [])
  .component("captainPage", captain)
  .service("CaptainTransforms", CaptainTransforms)
  .config(captainUrls);

export default captainModule;



// WEBPACK FOOTER //
// ./src/pages/captain/captain.module.js